import { HandlerWithResult } from "@gtsanders/Store/GTSState";
import { SelectedWarehouse } from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehouseReducer";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Cart, updateCart } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = HandlerWithResult<SelectedWarehouse, Cart, { cartToUpdate: CartModel }>;

export const SetCartSelectedWarehosue: HandlerType = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart");
    }
    var tempProps: { [key: string]: string } = {};
    tempProps["SelectedWarehouse"] = props.parameter.SelectedWarehouse;
    tempProps["SelectedWarehouseDesc"] = props.parameter.SelectedWarehouseDesc;
    props.cartToUpdate = {
        ...cloneDeep(cart),
        properties: tempProps
    };
};

export const UpdateCart: HandlerType = async props => {
    props.result = (await updateCart({ cart: props.cartToUpdate })).cart;
};


export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const chain = [SetCartSelectedWarehosue, UpdateCart, LoadCart];
const updateSelectedWarehouse = createHandlerChainRunner(
    chain,
    "UpdateSelectedWarehouse",
);
export default updateSelectedWarehouse;

